export default __webpack_public_path__ + "static/media/1834.1ea4c3ac.png";